module.exports = "/dist/d2ad295b60682a6537c358e06ea80c61.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-300.woff2
// module id = 117
// module chunks = 0